<script>
  export default {
    name: 'not-found',
    data: () => ({}),
    computed: {},
    methods: {},
    created() {}
  }
</script>

<template>
  <v-sheet height="100%" width="100%" class="d-flex flex-column align-center justify-center">
    <p class="font-weight-bold primary--text">Sorry, this page was not found</p>
    <a href="/" class="mt-8 font-weight-bold primary--text">HOME</a>
  </v-sheet>
</template>

<style scoped></style>
